import moment from 'moment';

export const syncFormData = (formData, submit = false, callback = (value) => {}) => {
  //console.log('formData', formData);
  const setValueIfElementExists = (elementId, value) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.value = value || '';
    }
  };

  const setValueWithFallbacks = (elementId, primaryValue, ...fallbackValues) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.value = primaryValue || fallbackValues.find(value => value) || '';
    }
  };

  // Basic form fields
  setValueIfElementExists('e2g_quote_contact_name', formData.fullName);
  setValueIfElementExists('e2g_quote_partner_name', formData.companyName);
  setValueIfElementExists('e2g_quote_email_from', formData.email);
  setValueIfElementExists('e2g_quote_phone_mobile_search', formData.phoneNumber);
  setValueIfElementExists('e2g_quote_name', formData.fullName);
  setValueIfElementExists('e2g_quote_description', formData.message);
  setValueIfElementExists('e2g_quote_street', formData.street);
  setValueIfElementExists('e2g_quote_zip', formData.zipCode);
  setValueIfElementExists('e2g_quote_city', formData.city);
  setValueIfElementExists('e2g_quote_latest_delivery_date', moment(formData?.latestDeliveryDate).format('DD/MM/YYYY'));
  setValueIfElementExists('e2g_quote_shipment_recipient', formData.shipmentRecipient?.label);
  setValueIfElementExists('e2g_quote_message', formData.message);
  setValueIfElementExists('e2g_quote_selected_service', formData.selectedService);
  // Country selection logic
  const countryElement = document.getElementById('e2g_quote_country_id');
  if (countryElement) {
    const countryToSelect = Array.from(countryElement.options).find(option => option.text === formData.country);
    if (countryToSelect) {
      countryToSelect.selected = true;
    }
  }

  // Address and location fields with fallbacks
  setValueIfElementExists('e2g_quote_from_location', formData.fromLocation?.label);
  setValueWithFallbacks('e2g_quote_from_address', formData.fromAddress, formData.fromAirport?.label, formData.fromSeaport?.label, formData.fromStation?.label);

  setValueIfElementExists('e2g_quote_to_location', formData.toLocation?.label);
  setValueWithFallbacks('e2g_quote_to_address', formData.toAddress, formData.toAirport?.label, formData.toSeaport?.label, formData.toStation?.label);

  // Checkbox fields
  const setCheckboxIfElementExists = (elementId, value) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.checked = value || false;
    }
  };

  setCheckboxIfElementExists('e2g_quote_agree_to_contact', formData.agreeToContact);
  setCheckboxIfElementExists('e2g_quote_agree_to_offers', formData.agreeToOffers);
  setCheckboxIfElementExists('e2g_quote_understand_business_platform', formData.understandBusinessPlatform);
  setCheckboxIfElementExists('e2g_quote_pickup_required', formData.pickupRequired);
  setCheckboxIfElementExists('e2g_quote_delivered_to_recipient', formData.deliveredToRecipient);
  setCheckboxIfElementExists('e2g_quote_lc_handling', formData.lcHandling);
  setCheckboxIfElementExists('e2g_quote_secured_shipment', formData.securedShipment);

  // Other fields
  setValueIfElementExists('e2g_quote_incoterm', formData.incoterm);
  setValueIfElementExists('e2g_quote_incoterm_location', formData.incotermLocation);
  if (formData.collectionAddress) {
    const collectionAddress = `${formData.collectionAddress.addressLine}, ${formData.collectionAddress.streetNo}, ${formData.collectionAddress.city}, ${formData.collectionAddress.state}, ${formData.collectionAddress.country}, ${formData.collectionAddress.zipCode}`;
    setValueIfElementExists('e2g_quote_collection_address', collectionAddress);
  }
  setValueIfElementExists('e2g_quote_role', formData.role);
  setValueIfElementExists('e2g_quote_cargo_ready_date', moment(formData?.cargoReadyDate).format('DD/MM/YYYY'));
  setValueIfElementExists('e2g_quote_note', formData.note);
  setValueIfElementExists('e2g_quote_flow', formData.flow);
  

  // Items and reference fields
  const itemsElement = document.getElementById('e2g_quote_items');


  
  if (itemsElement && formData.items) {
    itemsElement.value = formData.items
      .map(item => `Pieces: ${item.pieces}, Package Type: ${item.packageType.label}, Commodity: ${item.commodity}, Weight/Piece: ${item.weightPerPiece}, Total Weight: ${item.totalWeight}, Length/Piece: ${item.lengthPerPiece}, Width/Piece: ${item.widthPerPiece}, Height/Piece: ${item.heightPerPiece}, Volume Total: ${item.volumeTotal}, Dangerous Goods: ${item.dangerousGoods}, Stackable: ${item.stackable}, HS Code: ${item.hsCode}, Cargo Description: ${item.cargoDescription}`)
      .join('\n');
  }

  const referenceElement = document.getElementById('e2g_quote_reference');
  if (referenceElement && formData.references) {
    referenceElement.value = formData.references
      .map(ref => {
        let referenceString = '';
        if (ref.referenceType?.label) {
          referenceString += `Type: ${ref.referenceType.label}`;
        }
        if (ref.referenceNo) {
          if (referenceString) referenceString += ', ';
          referenceString += `Reference No: ${ref.referenceNo}`;
        }
        return referenceString;
      })
      .filter(ref => ref) // Filter out empty strings
      .join('\n');
  }

  const e2gSubmitQuote = document.getElementById('e2g_submit_quote');
  if(e2gSubmitQuote && submit){
      e2gSubmitQuote.click();
      setTimeout(() => {
        const errorElement = document.getElementById('s_website_form_result');
        if (errorElement && errorElement.innerText.trim()) {
              callback(errorElement.innerText.trim());
         }
      }, 1000);
  }
};
